import React, { useEffect, useState, useCallback } from "react";
import ReactTooltip from "react-tooltip";
import { ReactComponent as CheckMark } from "../assets/img/SVG/check-mark.svg";
import { SeatIcon, WCIcon } from "../assets/img/event/svg";

export default function Seat({
    color = "#750D37",
    taken = false,
    name = false,
    selected = false,
    blank,
    onClick,
    sm,
    data,
    ada = false,
    wc = false,
    client,
    unclickable = false,
    isEventManager = false
}) {
    const [isTaken, setIsTaken] = useState(taken);
    const [isSelected, setIsSelected] = useState(selected);

    useEffect(() => {
        setIsTaken(taken);
    }, [color, taken, data]);

    useEffect(() => {
        setIsSelected(selected);
    }, [selected, color]);

    const toggleSeat = useCallback(() => {
        if ((isTaken && !isEventManager) || blank || unclickable) {
            return;
        }

        const newSelectedState = !isSelected;
        setIsSelected(newSelectedState);

        function cb() {
            setIsSelected(selected);
        }
        onClick(data, cb);
    }, [isTaken, blank, unclickable, isSelected, onClick, data, selected, isEventManager]);

    return (
        <>
            <div
                className={`${blank ? "seat--blank" : ""} ${sm ? "seat--sm" : "seat"} ${isTaken ? "seat--taken" : ""}`}
                style={{ color: `${isTaken ? "#707070" : "#0029FF"}` }}
                onClick={toggleSeat}
            >
                {!isSelected ?
                    <>
                        {wc ? (
                          <WCIcon className="seat--wc" />
                        ) : ada ? (
                          <SeatIcon style={{ color: `${isTaken ? "#707070" : "#000000"}`, fill: `${isTaken ? "#707070" : "#000000"}` }} />
                        ) : (
                          <SeatIcon style={{ color: `${isTaken ? "#707070" : "#0029FF"}`, fill: `${isTaken ? "#707070" : "#0029FF"}` }} />
                        )}
                    </> :
                    <>
                        <CheckMark className="seat--selected" />
                    </>}
            </div>
            {blank ? null : <ReactTooltip id={`seat${name}`}>{name}</ReactTooltip>}
        </>
    );
}